import {Injectable} from "@angular/core";

@Injectable()
export class SessionStorageService {
  private readonly browserMode: boolean;
  private serviceStorage = new Map<string, string>();

  constructor() {
    try {
      this.browserMode = sessionStorage && !sessionStorage.getItem('browserMode');
    }
    catch(e) {
      console.log('Use a Map instead the sessionStorage');
      this.browserMode = false;
    }
  }

  clear(): void {
    if(this.browserMode)
      sessionStorage.clear();
    else
      this.serviceStorage.clear();
  }

  getItem(key: string): string | null {
    return this.browserMode ? sessionStorage.getItem(key) : (this.serviceStorage.get(key) || null);
  }

  removeItem(key: string): void {
    if(this.browserMode)
      sessionStorage.removeItem(key);
    else
      this.serviceStorage.delete(key);
  }

  setItem(key: string, value: string): void {
    if(this.browserMode)
      sessionStorage.setItem(key, value);
    else
      this.serviceStorage.set(key, value);
  }
}
